import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.keys";
import _typeof from "E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 天地图原生 JS API 封装（无第三方 Vue 包）
// 保持与原百度地图组件相同的 props / events / method，调用方无需改动
//   props: center / isEdit / zooms / height
//   events: locationOk(center) / setShopInfo(info)
//   method: setMapLayer(markers)  markers: [{lng,lat,title,icon?,...}]

// 行政区中心经纬度查表（兜底定位）
// 仅收录常用省/市/区县，缺项返回 null；可按需扩展
var ADMIN_CENTERS = {
  // —— 福建省 ——
  '福建省': {
    lng: 119.296,
    lat: 26.075
  },
  '福州市': {
    lng: 119.296,
    lat: 26.075
  },
  '鼓楼区': {
    lng: 119.305,
    lat: 26.082
  },
  '台江区': {
    lng: 119.314,
    lat: 26.058
  },
  '仓山区': {
    lng: 119.273,
    lat: 26.039
  },
  '马尾区': {
    lng: 119.439,
    lat: 26.039
  },
  '晋安区': {
    lng: 119.328,
    lat: 26.082
  },
  '长乐区': {
    lng: 119.523,
    lat: 25.962
  },
  '闽侯县': {
    lng: 119.131,
    lat: 26.150
  },
  '连江县': {
    lng: 119.539,
    lat: 26.197
  },
  '闽清县': {
    lng: 118.862,
    lat: 26.218
  },
  '永泰县': {
    lng: 118.932,
    lat: 25.867
  },
  '福清市': {
    lng: 119.384,
    lat: 25.720
  },
  '平潭县': {
    lng: 119.790,
    lat: 25.503
  },
  '厦门市': {
    lng: 118.110,
    lat: 24.490
  },
  '思明区': {
    lng: 118.082,
    lat: 24.446
  },
  '湖里区': {
    lng: 118.146,
    lat: 24.512
  },
  '集美区': {
    lng: 118.097,
    lat: 24.575
  },
  '海沧区': {
    lng: 117.984,
    lat: 24.485
  },
  '同安区': {
    lng: 118.150,
    lat: 24.722
  },
  '翔安区': {
    lng: 118.247,
    lat: 24.620
  },
  '泉州市': {
    lng: 118.675,
    lat: 24.874
  },
  '漳州市': {
    lng: 117.647,
    lat: 24.513
  },
  '莆田市': {
    lng: 119.007,
    lat: 25.431
  },
  '三明市': {
    lng: 117.639,
    lat: 26.264
  },
  '南平市': {
    lng: 118.178,
    lat: 26.636
  },
  '龙岩市': {
    lng: 117.030,
    lat: 25.091
  },
  '宁德市': {
    lng: 119.527,
    lat: 26.659
  },
  // —— 广东省 ——
  '广东省': {
    lng: 113.266,
    lat: 23.133
  },
  '广州市': {
    lng: 113.264,
    lat: 23.129
  },
  '天河区': {
    lng: 113.361,
    lat: 23.124
  },
  '越秀区': {
    lng: 113.266,
    lat: 23.129
  },
  '海珠区': {
    lng: 113.317,
    lat: 23.083
  },
  '番禺区': {
    lng: 113.384,
    lat: 22.937
  },
  '白云区': {
    lng: 113.273,
    lat: 23.158
  },
  '深圳市': {
    lng: 114.057,
    lat: 22.543
  },
  '福田区': {
    lng: 114.055,
    lat: 22.521
  },
  '南山区': {
    lng: 113.930,
    lat: 22.533
  },
  '宝安区': {
    lng: 113.884,
    lat: 22.555
  },
  '罗湖区': {
    lng: 114.131,
    lat: 22.548
  },
  '龙岗区': {
    lng: 114.246,
    lat: 22.720
  },
  '东莞市': {
    lng: 113.751,
    lat: 23.041
  },
  '佛山市': {
    lng: 113.122,
    lat: 23.029
  },
  '中山市': {
    lng: 113.382,
    lat: 22.521
  },
  '珠海市': {
    lng: 113.576,
    lat: 22.271
  },
  '惠州市': {
    lng: 114.412,
    lat: 23.112
  },
  '汕头市': {
    lng: 116.682,
    lat: 23.354
  },
  // —— 直辖市 ——
  '北京市': {
    lng: 116.407,
    lat: 39.904
  },
  '东城区': {
    lng: 116.418,
    lat: 39.928
  },
  '西城区': {
    lng: 116.366,
    lat: 39.912
  },
  '朝阳区': {
    lng: 116.601,
    lat: 39.929
  },
  '海淀区': {
    lng: 116.296,
    lat: 39.959
  },
  '上海市': {
    lng: 121.473,
    lat: 31.230
  },
  '黄浦区': {
    lng: 121.484,
    lat: 31.232
  },
  '徐汇区': {
    lng: 121.437,
    lat: 31.188
  },
  '长宁区': {
    lng: 121.424,
    lat: 31.220
  },
  '静安区': {
    lng: 121.448,
    lat: 31.229
  },
  '浦东新区': {
    lng: 121.544,
    lat: 31.222
  },
  '天津市': {
    lng: 117.190,
    lat: 39.125
  },
  '重庆市': {
    lng: 106.551,
    lat: 29.563
  },
  // —— 浙江省 ——
  '浙江省': {
    lng: 120.152,
    lat: 30.276
  },
  '杭州市': {
    lng: 120.155,
    lat: 30.275
  },
  '宁波市': {
    lng: 121.622,
    lat: 29.868
  },
  '温州市': {
    lng: 120.672,
    lat: 28.001
  },
  '绍兴市': {
    lng: 120.582,
    lat: 30.030
  },
  '嘉兴市': {
    lng: 120.750,
    lat: 30.762
  },
  '金华市': {
    lng: 119.647,
    lat: 29.079
  },
  // —— 江苏省 ——
  '江苏省': {
    lng: 118.778,
    lat: 32.066
  },
  '南京市': {
    lng: 118.778,
    lat: 32.066
  },
  '苏州市': {
    lng: 120.585,
    lat: 31.299
  },
  '无锡市': {
    lng: 120.302,
    lat: 31.575
  },
  '常州市': {
    lng: 119.974,
    lat: 31.811
  },
  '南通市': {
    lng: 120.894,
    lat: 31.980
  },
  // —— 其他常见省/市 ——
  '山东省': {
    lng: 117.020,
    lat: 36.651
  },
  '济南市': {
    lng: 117.120,
    lat: 36.651
  },
  '青岛市': {
    lng: 120.382,
    lat: 36.067
  },
  '四川省': {
    lng: 102.693,
    lat: 30.674
  },
  '成都市': {
    lng: 104.067,
    lat: 30.667
  },
  '湖北省': {
    lng: 114.342,
    lat: 30.546
  },
  '武汉市': {
    lng: 114.305,
    lat: 30.593
  },
  '湖南省': {
    lng: 112.983,
    lat: 28.113
  },
  '长沙市': {
    lng: 112.938,
    lat: 28.228
  },
  '河南省': {
    lng: 113.625,
    lat: 34.747
  },
  '郑州市': {
    lng: 113.625,
    lat: 34.747
  },
  '陕西省': {
    lng: 108.954,
    lat: 34.264
  },
  '西安市': {
    lng: 108.940,
    lat: 34.341
  },
  '云南省': {
    lng: 102.712,
    lat: 25.040
  },
  '昆明市': {
    lng: 102.832,
    lat: 24.880
  }
};
export default {
  name: 'TdtMap',
  props: {
    center: {
      type: Object,
      default: function _default() {
        return {
          lng: 114.02597366,
          lat: 22.54605355
        };
      }
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    zooms: {
      type: Number,
      default: 14
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  data: function data() {
    return {
      keyword: '',
      searchResults: [],
      map: null,
      // T.Map 实例
      markerList: [],
      // setMapLayer 添加的 marker 列表（用于清理）
      infoWindow: null,
      // T.InfoWindow 实例
      geolocation: null,
      localSearch: null,
      tdtKey: '',
      sdkReady: false,
      // 输入即跳相关
      lastInputAt: 0,
      // 最近一次输入时间戳
      searchVersion: 0,
      // 自增：每次发起的搜索编号
      pendingSearchVersion: 0 // 本次回调对应的搜索编号
    };
  },
  watch: {
    // 父组件 center（经纬度）异步变化时（如编辑商户 getInfo 返回后），
    // 重新居中地图；centerAndZoom 会触发 moveend -> onMoveEnd -> emit locationOk，
    // 从而回填父组件的 latitude/longitude（等价于 vue-baidu-map 对 :center 的响应式处理）
    center: {
      deep: true,
      handler: function handler(val) {
        if (!val) return;
        // 回填地址文本到输入框（仅在父组件给了 keyword 且当前 input 为空/不同时）
        if (val.keyword != null && val.keyword !== this.keyword) {
          // 编辑态初次加载：用父组件 keyword 直接回填，不走搜索
          // 拖动地图时 onMoveEnd 也会改 center.keyword，要避免覆盖用户输入
          if (!this._userEdited) {
            this.keyword = val.keyword;
          }
        }
        if (!this.map || !window.T) return;
        if (!(val.lng && val.lat)) return;
        try {
          var c = this.map.getCenter();
          // 与当前地图中心一致则跳过，避免回环（拖动地图时 onMoveEnd 也会改 center）
          if (c && Math.abs(c.lng - val.lng) < 1e-6 && Math.abs(c.lat - val.lat) < 1e-6) return;
          this.map.centerAndZoom(new window.T.LngLat(val.lng, val.lat), this.zooms);
        } catch (e) {
          console.warn('center变化重新居中失败:', e);
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.tdtKey = this.config && (this.config.tianditu_key || this.config.baidu_map_ak) || '';
    // 编辑态初次加载：把父组件传入的 center.keyword 回填到输入框
    if (this.center && this.center.keyword) {
      this.keyword = this.center.keyword;
    }
    this.loadSdk().then(function () {
      _this.initMap();
      // 编辑态：父组件只传了 lng/lat（没传 keyword），逆地理一次拿地址回填输入框
      if (_this.isEdit && _this.center && _this.center.lng && _this.center.lat && !_this.keyword) {
        _this.$nextTick(function () {
          return _this.reverseGeocode(_this.center.lng, _this.center.lat);
        });
      }
    }).catch(function (err) {
      console.error('天地图SDK加载失败:', err);
    });
  },
  methods: {
    /**
     * 动态加载天地图 JS SDK
     */
    /**
     * 输入即搜索（debounce 350ms），避免连续敲键盘时反复请求
     */
    onKeywordInput: function () {
      var timer = null;
      return function () {
        var _this2 = this;
        this.lastInputAt = Date.now();
        this._userEdited = true;
        clearTimeout(timer);
        timer = setTimeout(function () {
          return _this2.searchKeyword();
        }, 350);
      };
    }(),
    /**
     * 清空时直接清空结果列表
     */
    onKeywordClear: function onKeywordClear() {
      this.searchResults = [];
      this.lastInputAt = 0;
      this._userEdited = true;
    },
    loadSdk: function loadSdk() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        if (window.T) {
          _this3.sdkReady = true;
          resolve();
          return;
        }
        if (!_this3.tdtKey) {
          reject(new Error('缺少天地图key，请在config.json配置 tianditu_key 或 baidu_map_ak'));
          return;
        }
        var src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=' + encodeURIComponent(_this3.tdtKey);
        var existing = document.querySelector('script[src^="https://api.tianditu.gov.cn/api"]');
        if (existing) {
          if (window.T) {
            _this3.sdkReady = true;
            resolve();
          } else {
            existing.addEventListener('load', function () {
              _this3.sdkReady = true;
              resolve();
            });
            existing.addEventListener('error', reject);
          }
          return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = function () {
          _this3.sdkReady = true;
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    /**
     * 初始化天地图
     */
    initMap: function initMap() {
      if (!window.T) return;
      var T = window.T;
      var lng = this.center && this.center.lng ? this.center.lng : 116.40769;
      var lat = this.center && this.center.lat ? this.center.lat : 39.89945;
      this.map = new T.Map(this.$refs.tdtMap, {
        projection: 'EPSG:900913'
      });
      this.map.centerAndZoom(new T.LngLat(lng, lat), this.zooms);

      // 限制只显示中国区域，避免全球平铺重复
      try {
        // 中国大致范围（经度73~135,纬度18~54）
        var bounds = new T.LngLatBounds(new T.LngLat(73.0, 18.0), new T.LngLat(135.0, 54.0));
        this.map.setMaxBounds(bounds);
        // 限制缩放级别（天地图 4=全球,5=洲,6=省,12=街道）
        this.map.setMinZoom(4);
        this.map.setMaxZoom(18);
      } catch (e) {
        console.warn('限制范围失败（可忽略）:', e);
      }

      // 控件：缩放、比例尺
      try {
        this.map.addControl(new T.Control.Zoom());
        this.map.addControl(new T.Control.Scale());
      } catch (e) {}

      // 移动结束 -> 更新中心点 -> locationOk
      this.map.addEventListener('moveend', this.onMoveEnd);
      // 点击空白 -> 关闭信息窗口 / 清空选中
      this.map.addEventListener('click', this.onMapClick);

      // 编辑态：未传center时尝试定位
      if (this.isEdit && !(this.center && this.center.lng)) {
        this.locateSelf();
      }
    },
    /**
     * 浏览器定位
     */
    locateSelf: function locateSelf() {
      var _this4 = this;
      var T = window.T;
      try {
        var geo = new T.Geolocation();
        geo.getCurrentPosition(function (r) {
          if (r && r.lng && r.lat) {
            _this4.map.centerAndZoom(new T.LngLat(r.lng, r.lat), _this4.zooms);
            _this4.onMoveEnd();
          }
        });
      } catch (e) {
        console.warn('定位失败:', e);
      }
    },
    /**
     * 地图移动结束，同步 center 并 emit locationOk
     */
    onMoveEnd: function onMoveEnd() {
      if (!this.map) return;
      var c = this.map.getCenter();
      if (!c) return;
      this.center.lng = c.lng;
      this.center.lat = c.lat;
      this.update();
    },
    /**
     * 地图点击空白处
     * 编辑态：清空选中 + 平移到点击位置 → emit locationOk 回填父表单 lng/lat
     * 展示态：清空选中 + 关闭信息窗
     */
    onMapClick: function onMapClick(e) {
      // 关闭信息窗口
      if (this.infoWindow) {
        try {
          this.map.closeInfoWindow();
        } catch (err) {}
      }
      // 清空选中门店
      this.$emit('setShopInfo', {});
      if (!this.isEdit) return;
      // 取点击位置的经纬度（天地图 v4 事件对象 e.lnglat）
      var ll = e && (e.lnglat || e.latlng);
      if (!ll || ll.lng == null || ll.lat == null) return;
      var lng = Number(ll.lng);
      var lat = Number(ll.lat);
      if (isNaN(lng) || isNaN(lat)) return;
      var T = window.T;
      if (!this.map || !T) return;
      // 平移到点击位置（保持当前缩放级别）
      this.map.panTo(new T.LngLat(lng, lat));
      // 同步 center / 回填父表单（panTo 会触发 moveend 重新走 onMoveEnd，
      // 但中心值已经被这里显式设置，避免中间态不一致）
      this.center.lng = lng;
      this.center.lat = lat;
      this.update();
      // 逆地理 → 回填输入框（不触发搜索，避免与"输入即跳"互踩）
      this.reverseGeocode(lng, lat);
    },
    /**
     * 逆地理编码（lng/lat → 地址文本），回填到搜索输入框
     * 仅在编辑态被点击地图时调用，不会触发搜索逻辑
     */
    reverseGeocode: function reverseGeocode(lng, lat) {
      var _this5 = this;
      var T = window.T;
      if (!T || typeof T.Geocoder !== 'function') return;
      try {
        var geo = new T.Geocoder();
        geo.getLocation(new T.LngLat(lng, lat), function (result) {
          try {
            var addr = result && result.getAddress && result.getAddress();
            if (addr) {
              // 静默赋值：不触发 input 事件，不更新 lastInputAt，不启动 debounce 搜索
              // 实现：直接改 data 但绕开 v-model 触发的 input 事件。
              // Vue 2 中通过 setTimeout/nextTick 同步 data 仍会触发 input，最简单的做法是
              // 给 _userEdited 置 true 并清空 lastInputAt，下次搜索回调的 800ms 静默判定会因 lastInputAt=0 而不自动跳
              _this5.keyword = addr;
              if (_this5.center) _this5.center.keyword = addr;
              _this5._userEdited = true;
              _this5.lastInputAt = 0;
            }
          } catch (e) {
            console.warn('[reverseGeocode] 解析失败:', e);
          }
        });
      } catch (e) {
        console.warn('[reverseGeocode] 逆地理请求失败:', e);
      }
    },
    /**
     * 设置门店点位图层（父组件通过 ref 调用）
     * markers: [{lng, lat, title, icon?, ...任意tag数据}]
     */
    setMapLayer: function setMapLayer(markers) {
      var _this6 = this;
      var T = window.T;
      if (!this.map || !T) return;

      // 清理旧 marker（用 addOverLay 添加的需要逐个 removeOverLay）
      if (this.markerList && this.markerList.length) {
        this.markerList.forEach(function (m) {
          try {
            _this6.map.removeOverLay(m);
          } catch (e) {}
        });
      }
      this.markerList = [];
      if (!markers || !markers.length) return;
      var validMarkers = markers.filter(function (m) {
        return m.lng && m.lat;
      });
      if (!validMarkers.length) return;
      validMarkers.forEach(function (item) {
        var marker = new T.Marker(new T.LngLat(item.lng, item.lat));
        // 点击 marker -> emit setShopInfo + 打开信息窗口
        marker.addEventListener('click', function (e) {
          // 阻止冒泡到 map click，否则会被 onMapClick 立刻清空选中
          try {
            e && e.stopPropagation && e.stopPropagation();
          } catch (err) {}
          try {
            window.event && (window.event.cancelBubble = true);
          } catch (err) {}
          _this6.$emit('setShopInfo', item);
          _this6.openInfoWindow(item);
        });
        _this6.map.addOverLay(marker);
        _this6.markerList.push(marker);
      });

      // 自动适配视野：单点居中，多点 getViewport
      try {
        if (validMarkers.length === 1) {
          this.map.centerAndZoom(new T.LngLat(validMarkers[0].lng, validMarkers[0].lat), Math.max(this.zooms, 12));
        } else {
          var points = validMarkers.map(function (m) {
            return new T.LngLat(m.lng, m.lat);
          });
          var viewport = this.map.getViewport(points);
          // getViewport 返回 {center, zoomLevel} 或类似结构，做兼容
          var center = viewport.center || viewport;
          var zoom = viewport.zoomLevel || viewport.zoom || 10;
          this.map.centerAndZoom(center, zoom > 12 ? 12 : zoom);
        }
      } catch (e) {
        console.warn('视野适配失败:', e);
      }
    },
    /**
     * 打开信息窗口（先关闭上一个，避免 InfoWindow 堆积导致卡顿）
     */
    openInfoWindow: function openInfoWindow(marker) {
      var T = window.T;
      if (!this.map || !T) return;
      var html = marker.title || '未命名点位';
      try {
        // 先关掉旧窗口（marker click 连续触发时避免堆叠）
        if (this.infoWindow) {
          try {
            this.map.closeInfoWindow();
          } catch (e) {}
        }
        var iw = new T.InfoWindow(html, {
          minWidth: 120,
          maxHeight: 100
        });
        this.map.openInfoWindow(iw, new T.LngLat(marker.lng, marker.lat));
        this.infoWindow = iw;
      } catch (e) {
        console.warn('信息窗口打开失败:', e);
      }
    },
    /**
     * 搜索（回车 / 点击按钮触发）
     * 天地图原生 LocalSearch，返回结果有 WGS-84 (lon/lat) 与墨卡托 (lonlat) 两种坐标。
     * 这里取 lonlat（搜出来的视野框坐标系），点击时再转换。
     */
    searchKeyword: function searchKeyword() {
      var _this7 = this;
      var kw = (this.keyword || '').trim();
      if (!kw) {
        this.searchResults = [];
        return;
      }
      //地图未初始化完成时（SDK 异步加载、首次打开），等待 200ms 再试，最多 25 次（≈5s）
      if (!this.map) {
        if (!this._searchRetry) this._searchRetry = 0;
        if (this._searchRetry < 25) {
          this._searchRetry++;
          setTimeout(function () {
            return _this7.searchKeyword();
          }, 200);
          return;
        }
        this._searchRetry = 0;
        console.warn('[searchKeyword] 地图尚未初始化，无法搜索');
        this.$message && this.$message({
          message: '地图加载中，请稍后再试',
          type: 'warning'
        });
        return;
      }
      this._searchRetry = 0;
      var T = window.T;
      if (!T) {
        console.warn('[searchKeyword] window.T 不存在（SDK 未加载）');
        this.searchResults = [];
        return;
      }
      try {
        var that = this;
        // 清理上一次搜索实例，避免回调堆积
        if (this.localSearch && typeof this.localSearch.clear === 'function') {
          try {
            this.localSearch.clear();
          } catch (e) {}
        }
        this.localSearch = null;
        this.searchResults = [];
        this.searchVersion++;
        this.pendingSearchVersion = this.searchVersion;
        var ls = new T.LocalSearch(this.map, {
          pageCapacity: 10,
          // 关键：多个版本字段名不一致，做兼容
          onSearchComplete: function onSearchComplete(result) {
            var list = [];
            var pois = [];
            try {
              // 优先尝试官方方法
              var obj = result && result.obj;
              if (obj) {
                if (typeof obj.getResult === 'function') {
                  pois = obj.getResult() || [];
                }
                if (!pois.length && typeof obj.getArea === 'function') {
                  pois = obj.getArea() || [];
                }
                if (!pois.length && typeof obj.getPois === 'function') {
                  pois = obj.getPois() || [];
                }
                // 兜底：直接从实例属性拿（obj.count=10 暗示 obj.result 是真实数据载体）
                if (!pois.length) {
                  // 探测 lsResult/result 内每个字段是否是数组（排除 prompt 提示字段）
                  var SKIP_KEYS = ['prompt', 'suggests', 'statistics', 'area'];
                  var probe = function probe(o) {
                    if (!o || _typeof(o) !== 'object') return null;
                    for (var _i = 0, _Object$keys = Object.keys(o); _i < _Object$keys.length; _i++) {
                      var k = _Object$keys[_i];
                      if (SKIP_KEYS.indexOf(k) >= 0) continue;
                      if (Array.isArray(o[k]) && o[k].length) {
                        return o[k];
                      }
                      if (o[k] && _typeof(o[k]) === 'object') {
                        for (var _i2 = 0, _Object$keys2 = Object.keys(o[k]); _i2 < _Object$keys2.length; _i2++) {
                          var k2 = _Object$keys2[_i2];
                          if (SKIP_KEYS.indexOf(k2) >= 0) continue;
                          if (Array.isArray(o[k][k2]) && o[k][k2].length) {
                            return o[k][k2];
                          }
                        }
                      }
                    }
                    return null;
                  };
                  pois = probe(obj.lsResult) || probe(obj.result) || [];
                }

                // resultType=3（行政区划）兜底：本地维护的「行政中心经纬度」对照表
                // 已确认 v2/admins 接口 404、result.result 没有 bounds，因此只能用查表
                if (!pois.length && result && result.resultType === 3) {
                  var center = that.lookupAdminCenter(result.keyWord);
                  if (center) {
                    pois = [{
                      __syntheticAdmin: true,
                      adminCode: result.result && result.result.adminCode,
                      adminName: result.keyWord,
                      keyword: result.keyWord,
                      center: center
                    }];
                  }
                }
              }
              // resultType=3 行政区划 / 1 POI / 2 公交等：行政区划时数据藏在 result.result.prompt[].admins 里
              if (!pois.length && result && result.resultType === 3 && result.result) {
                // 行政区匹配项在 prompt 数组里，每项含 admins 数组
                var prompts = result.result.prompt || [];
                var adminItems = [];
                prompts.forEach(function (p) {
                  if (p && Array.isArray(p.admins)) {
                    p.admins.forEach(function (a) {
                      return adminItems.push({
                        adminCode: a.adminCode,
                        adminName: a.adminName,
                        keyword: p.keyword || result.keyWord || ''
                      });
                    });
                  }
                });
                pois = adminItems;
              }
              // 最后退化：result.result / result.pois
              if (!pois.length && result && Array.isArray(result.result)) {
                pois = result.result;
              }
              if (!pois.length && result && Array.isArray(result.pois)) {
                pois = result.pois;
              }
            } catch (e) {
              console.warn('[searchKeyword] 读取 pois 失败:', e);
            }
            pois.forEach(function (p) {
              // 行政区项（adminCode/adminName 或合成中心点）→ 直接放进列表
              if (p && (p.adminCode || p.__syntheticAdmin)) {
                list.push({
                  title: p.adminName || p.keyword || '',
                  address: '',
                  lng: p.center ? p.center.lng : null,
                  lat: p.center ? p.center.lat : null,
                  isAdmin: true,
                  adminCode: p.adminCode,
                  adminName: p.adminName
                });
                return;
              }
              // 多种可能的字段名（天地图各版本 + 兜底扫描）
              // 注意：v4 SDK 中 p.lonlat 是 "lon,lat" 字符串，而非对象
              var lon = null,
                lat = null;
              var llRaw = p.lonlat || p.pointLonlat || p.location || p.coordinate;
              if (llRaw != null) {
                if (typeof llRaw === 'string' && llRaw.indexOf(',') >= 0) {
                  var parts = llRaw.split(',');
                  lon = parseFloat(parts[0]);
                  lat = parseFloat(parts[1]);
                } else if (_typeof(llRaw) === 'object') {
                  lon = llRaw.lon != null ? llRaw.lon : llRaw.lng;
                  lat = llRaw.lat != null ? llRaw.lat : llRaw.lat;
                }
              }
              if (lon == null) lon = p.lon;
              if (lat == null) lat = p.lat;
              var bounds = p.bounds || p.mapBound;
              if (lon != null && lat != null && !isNaN(lon) && !isNaN(lat)) {
                list.push({
                  title: p.title || p.name || '',
                  address: p.address || '',
                  lng: lon,
                  lat: lat
                });
              } else if (bounds && Array.isArray(bounds) && bounds.length) {
                var minLng = Infinity,
                  maxLng = -Infinity,
                  minLat = Infinity,
                  maxLat = -Infinity;
                bounds.forEach(function (b) {
                  if (_typeof(b) === 'object' && b.lng !== undefined) {
                    minLng = Math.min(minLng, b.lng);
                    maxLng = Math.max(maxLng, b.lng);
                    minLat = Math.min(minLat, b.lat);
                    maxLat = Math.max(maxLat, b.lat);
                  }
                });
                if (minLng !== Infinity) {
                  list.push({
                    title: p.title || p.name || '',
                    address: p.address || '',
                    lng: (minLng + maxLng) / 2,
                    lat: (minLat + maxLat) / 2
                  });
                }
              } else if (p.area && Array.isArray(p.area) && p.area.length) {
                var _minLng = Infinity,
                  _maxLng = -Infinity,
                  _minLat = Infinity,
                  _maxLat = -Infinity;
                p.area.forEach(function (pt) {
                  if (pt && pt.lng !== undefined) {
                    _minLng = Math.min(_minLng, pt.lng);
                    _maxLng = Math.max(_maxLng, pt.lng);
                    _minLat = Math.min(_minLat, pt.lat);
                    _maxLat = Math.max(_maxLat, pt.lat);
                  }
                });
                if (_minLng !== Infinity) {
                  list.push({
                    title: p.name || p.keyWord || '',
                    address: p.address || '',
                    lng: (_minLng + _maxLng) / 2,
                    lat: (_minLat + _maxLat) / 2
                  });
                }
              }
            });
            that.searchResults = list;

            // 输入即跳第一条结果（静默 800ms 后）
            try {
              var now = Date.now();
              var silent = now - that.lastInputAt;
              var versionMatch = that.pendingSearchVersion === that.searchVersion;
              if (list.length && that.lastInputAt && silent >= 800 && versionMatch) {
                // 异步执行，避免和本次回调逻辑互相干扰
                setTimeout(function () {
                  return that.selectResult(list[0]);
                }, 0);
              }
            } catch (e) {
              console.warn('[searchKeyword] 自动跳第一条失败:', e);
            }
          }
        });
        ls.search(this.keyword);
        this.localSearch = ls;
      } catch (e) {
        console.warn('[searchKeyword] 天地图搜索抛异常:', e);
        this.searchResults = [];
      }
    },
    /**
     * 选择搜索结果
     */
    selectResult: function selectResult(item) {
      var _this8 = this;
      if (!item) return;
      // 行政区项：优先用结果自带的中心点；缺中心点时退查表
      if (item.isAdmin) {
        var lng = item.lng;
        var lat = item.lat;
        if (!lng || !lat) {
          var c = this.lookupAdminCenter(item.adminName || item.title || '');
          if (c) {
            lng = c.lng;
            lat = c.lat;
          }
        }
        if (!lng || !lat) return;
        this.jumpTo(lng, lat, Math.min(this.zooms, 12));
        return;
      }
      // 普通 POI 项：有坐标直接跳
      if (item.lng != null && item.lat != null && !isNaN(item.lng) && !isNaN(item.lat)) {
        this.jumpTo(item.lng, item.lat, this.zooms);
        return;
      }
      // 兜底：用地址文本回查（地址项偶尔坐标缺失）
      if (item.title && this.keyword !== item.title) {
        this.keyword = item.title;
        this.$nextTick(function () {
          return _this8.searchKeyword();
        });
      }
    },
    /**
     * 统一执行地图跳转 + 关闭列表 + 通知父组件
     */
    jumpTo: function jumpTo(lng, lat, zoom) {
      var T = window.T;
      if (!this.map || !T) return;
      this.center.lng = lng;
      this.center.lat = lat;
      this.map.centerAndZoom(new T.LngLat(lng, lat), zoom);
      this.searchResults = [];
      this.update();
    },
    /**
     * 向父组件更新 center
     */
    update: function update() {
      this.center.keyword = this.keyword;
      this.$emit('locationOk', this.center);
    },
    /**
     * 行政区中心经纬度查表（兜底方案）
     * 天地图 v2/admins 接口已确认 404、result.result 无 bounds，
     * 用本地维护的「省/市/区县行政中心」对照表做定位。
     * key 支持：完整路径（'福建省福州市鼓楼区'）、末级名称（'鼓楼区'）、简写（'福州'）
     */
    lookupAdminCenter: function lookupAdminCenter(keyword) {
      if (!keyword) return null;
      var k = String(keyword).trim();
      // 1) 完整路径精确匹配（高优先级）
      if (ADMIN_CENTERS[k]) return ADMIN_CENTERS[k];
      // 2) 末级行政区名匹配（'福建省福州市鼓楼区' → '鼓楼区'）
      var last = k.replace(/^(.+?省|.+?市|.+?自治区|.+?特别行政区)/, '');
      if (last && ADMIN_CENTERS[last]) return ADMIN_CENTERS[last];
      // 3) 末级名带 '市'/'区'/'县' 变体匹配
      var stripped = last.replace(/(市|区|县|自治县|旗|自治旗)$/, '');
      for (var _i3 = 0, _Object$keys3 = Object.keys(ADMIN_CENTERS); _i3 < _Object$keys3.length; _i3++) {
        var name = _Object$keys3[_i3];
        var ns = name.replace(/(市|区|县|自治县|旗|自治旗)$/, '');
        if (ns && (ns === stripped || ns.indexOf(stripped) >= 0 || stripped.indexOf(ns) >= 0)) {
          return ADMIN_CENTERS[name];
        }
      }
      return null;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.map) {
      try {
        this.map.removeEventListener('moveend', this.onMoveEnd);
      } catch (e) {}
      try {
        this.map.removeEventListener('click', this.onMapClick);
      } catch (e) {}
    }
  }
};